import React, { useState } from 'react';
import HeroSection from './admin/HeroSection';
import AboutSection from './admin/AboutSection';
import NavbarSection from './admin/NavbarSection';
import ServicesSection from './admin/ServicesSection';
import TestimonialsSection from './admin/TestimonialsSection';
import BlogSection from './admin/BlogSection';
import ResourcesSection from './admin/ResourcesSection';
import ImagesSection from './admin/ImagesSection';
import ContactSection from './admin/ContactSection';

const AdminPanel = ({ siteData, updateSiteData, setSiteData }) => {
    const [activeTab, setActiveTab] = useState('hero');
    const [saving, setSaving] = useState(false);
    const [saveStatus, setSaveStatus] = useState('');

    const tabs = [
        { id: 'hero', label: 'Hero Section' },
        { id: 'about', label: 'About' },
        { id: 'services', label: 'Services' },
        { id: 'testimonials', label: 'Testimonials' },
        { id: 'blog', label: 'Blog' },
        { id: 'resources', label: 'Resources' },
        { id: 'navbar', label: 'Navigation' },
        { id: 'contact', label: 'Contact' },
        { id: 'images', label: 'Images' }
    ];

    const showSaveStatus = (message, isError = false) => {
        setSaveStatus({ message, isError });
        setTimeout(() => setSaveStatus(''), 3000);
    };

    const commonProps = {
        siteData,
        updateSiteData,
        setSiteData,
        saving,
        setSaving,
        showSaveStatus
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'hero':
                return <HeroSection {...commonProps} />;
            case 'about':
                return <AboutSection {...commonProps} />;
            case 'navbar':
                return <NavbarSection {...commonProps} />;
            case 'services':
                return <ServicesSection {...commonProps} />;
            case 'testimonials':
                return <TestimonialsSection {...commonProps} />;
            case 'blog':
                return <BlogSection {...commonProps} />;
            case 'resources':
                return <ResourcesSection {...commonProps} />;
            case 'images':
                return <ImagesSection {...commonProps} />;
            case 'contact':
                return <ContactSection {...commonProps} />;
            default:
                return <div>Select a tab to edit content</div>;
        }
    };

    return (
        <div className="min-h-screen bg-stone-100 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                    {/* Header */}
                    <div className="bg-stone-800 text-white p-6">
                        <h2 className="text-2xl font-bold">Admin Panel</h2>
                        <p className="text-stone-300 mt-1">Manage your website content</p>
                    </div>

                    {/* Save Status */}
                    {saveStatus && (
                        <div className={`px-6 py-3 text-sm ${saveStatus.isError
                            ? 'bg-red-100 text-red-700 border-b border-red-200'
                            : 'bg-green-100 text-green-700 border-b border-green-200'
                            }`}>
                            {saveStatus.message}
                        </div>
                    )}

                    {/* Tab Navigation */}
                    <div className="border-b border-stone-200">
                        <nav className="flex overflow-x-auto">
                            {tabs.map((tab) => (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`px-6 py-4 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab.id
                                        ? 'border-b-2 border-amber-500 text-amber-600 bg-amber-50'
                                        : 'text-stone-600 hover:text-stone-800 hover:bg-stone-50'
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Content */}
                    <div className="p-8">
                        {renderTabContent()}
                    </div>

                    {/* Save Notice */}
                    <div className="bg-amber-50 border-t border-amber-200 p-4">
                        <div className="flex items-center">
                            <svg className="w-5 h-5 text-amber-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p className="text-amber-700 text-sm">
                                Changes are automatically saved to Firebase. Exit admin mode to view your updated website.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;